<template>
    <div class="meeting-details max-content"
        style="background-image: url('https://cdn.edstatic.com/203012120000/31761403f5aa501eee66f8e8ea218d83/2026/02/2ee3d2ea-5bce-46c9-a7af-15ffcbcdfbe3.jpg');">

        <div class="banner-show">
            <div class="cover">
                <van-swipe :autoplay="3000" indicator-color="white" :show-indicators="false">
                    <van-swipe-item v-for="(item, key, index) in swiperImg" :key="index" @click="clickSwiperImg(item)">
                        <img :src="item.image" alt="">
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>
        <div class="relation717">
            <van-row>
                <van-col span="16">
                    <van-row>
                        <a href="Javascript:void(0)" title="picname" @click="skipLink(3510)">
                            <img src="https://cdn.edstatic.com/203012120000/1ef5b9d0905e8ee340e5becab2a5c0a9/2026/02/2cacb109-a614-47e7-aef2-9f0552d9d894.png" alt="">
                        </a>
                    </van-row>
                    <van-row>
                        <van-col span="12">
                            <a href="Javascript:void(0)" title="picname" @click="skipLink(3514)">
                                <img src="https://cdn.edstatic.com/203012120000/b7a46005dda5110f2f43f562f556baf6/2026/02/65167629-c906-4df6-a068-087b7429d19e.png" alt="">
                            </a>
                        </van-col>
                        <van-col span="12">
                            <a href="Javascript:void(0)" title="picname" @click="skipLink(3563)">
                                <img src="https://cdn.edstatic.com/203012120000/1f1dda63e672f1887898b8dbdde1528b/2026/02/f2f1b515-8b6f-4a42-b237-24f60a581b93.png" alt="">
                            </a>
                        </van-col>
                    </van-row>
                </van-col>
                <van-col span="8">
                    <a href="Javascript:void(0)" title="picname" @click="skipLink(3639)">
                        <img src="https://cdn.edstatic.com/203012120000/a28eca0af8fca79d061cbbf47306fde7/2026/02/95d84f57-79c9-488d-b2e1-0b04cf8e8452.png" alt="">
                    </a>
                </van-col>
            </van-row>
            <van-row>
                <van-col span="16">
                    <a href="Javascript:void(0)" title="picname" @click="skipLink(3640)">
                        <img src="https://cdn.edstatic.com/203012120000/1bb6d058a1d2fe93ec42961a4b2530db/2026/02/b01519e6-6d05-4d5a-8084-c5082c07ba81.png"
                            alt="">
                    </a>
                </van-col>
                <van-col span="8">
                    <a href="Javascript:void(0)" title="picname" @click="skipLink(3511)">
                        <img src="https://cdn.edstatic.com/203012120000/431e34f9fafe4403f2a6a999c106065e/2026/02/99b37fb4-5ddc-4a1d-891d-104679cb3720.png"
                            alt="">
                    </a>
                </van-col>

            </van-row>
            <van-row>
                <van-col span="8">
                    <a href="Javascript:void(0)" title="picname" @click="skipLink(3908)">
                        <img src="https://cdn.edstatic.com/203012120000/e3813b784af59a472c4018bd62eb60ca/2026/02/e5a525c5-88ac-45b9-bb7c-13495d7db830.png"
                            alt="">
                    </a>
                </van-col>
                <van-col span="8">
                    <a href="Javascript:void(0)" title="picname" @click="skipLink(3641)">
                        <img src="https://cdn.edstatic.com/203012120000/4681d7d39d7adf59c3dcd7e61d7d8a8f/2026/02/69baed10-e4c6-4471-b3fe-1fd3d6c7f038.png"
                            alt="">
                    </a>
                </van-col>
                <van-col span="8">
                    <a href="Javascript:void(0)" title="picname" @click="skipLink(3517)">
                        <img src="https://cdn.edstatic.com/203012120000/b6caef4de7da21c1606bd26509a465b9/2026/02/856833b4-13eb-4431-a625-3ac6c2d96123.png"
                            alt="">
                    </a>
                </van-col>
            </van-row>
        </div>
        <bottom :name="meeting_name" :meeting_id="meeting_id" :show_support="show_support" v-if="bottom_word_show">
        </bottom>
    </div>
</template>
<script>
// import Register from "../../components/Users/Register.vue"
import { MeetingButtons, MeetingsCarousel, MeetingsDetails, companyImages } from '../../../config/interface.js'
import { CountDown } from 'vant'
import Bottom from '../Meeting/Bottom.vue'
export default {
    components: {
        CountDown,
        Bottom
    },
    data() {
        return {
            meetingButton: {},    //会议按钮
            swiperImg: [],
            meeting_id: '717',
            time: '',
            showTimeCountDown: false,
            show_support: 1,
            bottom_word_show: 0
        }
    },
    beforeRouteEnter(to, from, next) {
        //  修复iOS版微信HTML5 History兼容性问题
        if (to.path !== location.pathname) {

            location.assign(to.fullPath)
        } else {
            next()
        }
    },
    mounted() {
        this.getMeetingButtons(this.meeting_id);
        this.getMeetingCarousel();
        this.getMeetingDetails();
    },
    methods: {
        getImages() {
            const url = companyImages;
            let params = {
                meeting_id: this.meeting_id,
            }
            const method = "POST";
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        this.images = res.data;
                    }
                })
        },
        //会议轮播
        getMeetingCarousel() {
            const url = MeetingsCarousel;
            let params = {
                meeting_id: this.meeting_id
            }
            const method = 'POST';
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        this.swiperImg = data;
                    }
                })
        },
        clickSwiperImg(item) {
            window.location.href = item.link;
        },
        //会议按钮
        getMeetingButtons(id) {
            const url = MeetingButtons;
            const method = 'POST';
            let params = {
                meeting_id: id
            };
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        this.meetingButton = data
                        // console.log(this.meetingButton)
                    }
                })
        },
        //会议详情
        getMeetingDetails() {
            const url = MeetingsDetails;
            const method = 'POST';
            let params = {
                meeting_id: this.meeting_id
            }
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        document.title = data.name;
                        this.meeting_name = data.name;
                        this.bottom_word_show = data.bottom_word_show;
                        this.show_support = data.platform_support_show;
                        // this.meeting_dates=data.meeting_dates;
                        this.time = this.countdownTo(data.start_at)
                        if (this.time <= 100) {
                            this.showTimeCountDown = false
                        } else {
                            this.showTimeCountDown = true

                        }

                        console.log(this.time)
                        //微信浏览器  请求jsdk
                        if (common.is_weixin()) {
                            common.wxShare(data.name, data.title, data.shareimg);
                        }
                    }
                })
        },
        countdownTo(targetDateString) {
            // 将目标日期字符串转换为Date对象
            const targetDate = new Date(targetDateString);
            // 获取当前时间的Date对象
            const currentDate = new Date();
            // 计算时间差（以毫秒为单位）
            const differenceMs = targetDate.getTime() - currentDate.getTime();
            // 返回剩余时间（如果为负数，则表示目标日期已过）
            return differenceMs;
        },
        // 将 skipLink 方法移至此处
        skipLink(id) {
            let item=null;
            for(var i=0;i<this.meetingButton.length;i++){
                if(this.meetingButton[i].id==id){
                    item=this.meetingButton[i];
                    break;
                }
            }
            console.log(item);
            if (item.url.match(/\.(jpeg|jpg|gif|png)$/)) {
                ImagePreview({
                    images: [item.url],
                    closeable: true,
                    showIndex: false
                });
            } else {
                window.localStorage.removeItem('callback_url');
                window.localStorage.setItem('callback_url', item.url);
                window.location.href = item.url;

                if (item.url.indexOf('vascularnews/meeting/schedule') > -1 && window.localStorage.getItem('schedule_date')) {
                    window.localStorage.removeItem('schedule_date');
                }
            }
        }

    }
}
</script>
<style lang="scss" scoped>
.meeting-details {
    display: flex;
    flex-direction: column;

    .banner-show {
        width: 100%;
        padding: 0px;

        .cover {
            width: 100%;

            img {
                width: 100%;
            }
        }
    }

    .relation717 {
        // overflow: auto;
        padding: 0.3rem 0.3rem;
        @include flex(row);
        align-items: center;
        flex-wrap: wrap;
        width: 100%;

        .van-row {
            width: 100%;
            line-height: 0;

        }

        .van-col {
            line-height: 0;
        }


        a {
            display: inline-block;
            text-align: center;
            line-height: 0;
            padding: 0.2rem;
            width: 100%;
            box-sizing: border-box;
            // margin-bottom: 16px;
        }

        img {
            width: 100%;
            height: 100%;

        }
    }

}

.countDown {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px 10px;
    width: fit-content;
    margin: 20px auto 10px;
    background: linear-gradient(275deg, #F2A22F 0%, #EE1E64 99%);
    border-radius: 8px;


    h4 {
        color: #fff;
        font-size: 12px;
        text-align: center;
        margin-right: 10px;
        font-weight: 500;
    }
}

.colon {
    display: inline-block;
    // margin: 0 4px;
    color: #ffffff;
    line-height: 30px;
    font-size: 12px;
    font-weight: 500;


}

.van-count-down {
    color: #fff;
}

.block {
    display: inline-block;
    color: #fff;
    font-size: 12px;
    text-align: center;
    border-radius: 5px;
    line-height: 20px;
    font-weight: 500;
    width: 28px;
    height: 20px;
    cursor: pointer;
    background: linear-gradient(180deg, #FACB61 0%, #F29C32 100%);
    background-blend-mode: normal, overlay, overlay;
    /* 添加外部阴影 */
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);

}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting717/index.vue